// Sample data for HMS demonstration
export const sampleData = {
  // Sample users for login (in real app, this would be in database)
  users: [
    {
      id: 1,
      username: "admin",
      password: "admin123",
      userType: "admin",
      name: "System Administrator",
      email: "admin@hospital.com",
    },
    {
      id: 2,
      username: "doctor1",
      password: "doc123",
      userType: "doctor",
      name: "Dr. John Smith",
      email: "john.smith@hospital.com",
      department: "Cardiology",
    },
    {
      id: 3,
      username: "nurse1",
      password: "nurse123",
      userType: "staff",
      name: "Sarah Johnson",
      email: "sarah.j@hospital.com",
      department: "Emergency",
    },
    {
      id: 4,
      username: "reception1",
      password: "rec123",
      userType: "reception",
      name: "Emily Davis",
      email: "emily.d@hospital.com",
    },
    {
      id: 5,
      username: "pharmacy1",
      password: "pharm123",
      userType: "pharmacy",
      name: "Mike Wilson",
      email: "mike.w@hospital.com",
    },
    {
      id: 6,
      username: "lab1",
      password: "lab123",
      userType: "lab",
      name: "Lisa Brown",
      email: "lisa.b@hospital.com",
    },
    {
      id: 7,
      username: "billing1",
      password: "bill123",
      userType: "billing",
      name: "David Lee",
      email: "david.l@hospital.com",
    },
    {
      id: 8,
      username: "patient1",
      password: "pat123",
      userType: "patient",
      name: "John Doe",
      email: "john.doe@email.com",
      patientId: "P0001",
    },
  ],

  // Sample patients data
  patients: [
    {
      id: 1,
      name: "John Doe",
      age: 35,
      gender: "Male",
      phone: "+91-9876543210",
      email: "john.doe@email.com",
      address: "123 Main Street, Mumbai, Maharashtra 400001",
      bloodGroup: "O+",
      status: "Active",
      lastVisit: "2024-01-15",
      emergencyContact: "+91-9876543211",
      medicalHistory: "Hypertension, Diabetes Type 2",
      registrationDate: "2023-06-15",
      patientId: "P0001",
    },
    {
      id: 2,
      name: "Jane Smith",
      age: 28,
      gender: "Female",
      phone: "+91-9876543212",
      email: "jane.smith@email.com",
      address: "456 Oak Avenue, Delhi, Delhi 110001",
      bloodGroup: "A+",
      status: "Active",
      lastVisit: "2024-01-10",
      emergencyContact: "+91-9876543213",
      medicalHistory: "Asthma, Allergic to Penicillin",
      registrationDate: "2023-08-20",
      patientId: "P0002",
    },
    {
      id: 3,
      name: "Rajesh Kumar",
      age: 45,
      gender: "Male",
      phone: "+91-9876543214",
      email: "rajesh.kumar@email.com",
      address: "789 Gandhi Road, Bangalore, Karnataka 560001",
      bloodGroup: "B+",
      status: "Active",
      lastVisit: "2024-01-18",
      emergencyContact: "+91-9876543215",
      medicalHistory: "Heart Disease, High Cholesterol",
      registrationDate: "2023-04-10",
      patientId: "P0003",
    },
    {
      id: 4,
      name: "Priya Sharma",
      age: 32,
      gender: "Female",
      phone: "+91-9876543216",
      email: "priya.sharma@email.com",
      address: "321 Park Street, Kolkata, West Bengal 700001",
      bloodGroup: "AB+",
      status: "Active",
      lastVisit: "2024-01-12",
      emergencyContact: "+91-9876543217",
      medicalHistory: "Thyroid, Migraine",
      registrationDate: "2023-09-05",
      patientId: "P0004",
    },
    {
      id: 5,
      name: "Mohammed Ali",
      age: 55,
      gender: "Male",
      phone: "+91-9876543218",
      email: "mohammed.ali@email.com",
      address: "654 Nehru Nagar, Hyderabad, Telangana 500001",
      bloodGroup: "O-",
      status: "Active",
      lastVisit: "2024-01-08",
      emergencyContact: "+91-9876543219",
      medicalHistory: "Kidney Stones, Arthritis",
      registrationDate: "2023-03-22",
      patientId: "P0005",
    },
  ],

  // Sample appointments data
  appointments: [
    {
      id: 1,
      patientName: "John Doe",
      patientId: "P0001",
      doctorName: "Dr. John Smith",
      department: "Cardiology",
      date: "2024-01-22",
      time: "10:00 AM",
      status: "Scheduled",
      type: "Consultation",
      notes: "Regular checkup for hypertension",
      appointmentId: "A0001",
    },
    {
      id: 2,
      patientName: "Jane Smith",
      patientId: "P0002",
      doctorName: "Dr. Sarah Johnson",
      department: "Pulmonology",
      date: "2024-01-22",
      time: "2:00 PM",
      status: "Completed",
      type: "Follow-up",
      notes: "Asthma follow-up, medication review",
      appointmentId: "A0002",
    },
    {
      id: 3,
      patientName: "Rajesh Kumar",
      patientId: "P0003",
      doctorName: "Dr. John Smith",
      department: "Cardiology",
      date: "2024-01-23",
      time: "11:30 AM",
      status: "Scheduled",
      type: "Consultation",
      notes: "Heart condition monitoring",
      appointmentId: "A0003",
    },
    {
      id: 4,
      patientName: "Priya Sharma",
      patientId: "P0004",
      doctorName: "Dr. Emily Brown",
      department: "Endocrinology",
      date: "2024-01-23",
      time: "3:30 PM",
      status: "Scheduled",
      type: "Follow-up",
      notes: "Thyroid function test results review",
      appointmentId: "A0004",
    },
    {
      id: 5,
      patientName: "Mohammed Ali",
      patientId: "P0005",
      doctorName: "Dr. David Lee",
      department: "Urology",
      date: "2024-01-24",
      time: "9:00 AM",
      status: "Scheduled",
      type: "Consultation",
      notes: "Kidney stone treatment consultation",
      appointmentId: "A0005",
    },
  ],

  // Sample staff data
  staff: [
    {
      id: 1,
      name: "Dr. John Smith",
      role: "Doctor",
      department: "Cardiology",
      specialization: "Interventional Cardiologist",
      phone: "+91-9876543220",
      email: "dr.smith@hospital.com",
      address: "123 Medical Colony, Mumbai",
      joinDate: "2020-01-15",
      salary: 250000,
      status: "Active",
      shift: "Morning",
      experience: "15 years",
      qualification: "MD Cardiology, MBBS",
      employeeId: "EMP001",
    },
    {
      id: 2,
      name: "Dr. Sarah Johnson",
      role: "Doctor",
      department: "Pulmonology",
      specialization: "Pulmonologist",
      phone: "+91-9876543221",
      email: "dr.johnson@hospital.com",
      address: "456 Doctor Street, Mumbai",
      joinDate: "2021-03-20",
      salary: 220000,
      status: "Active",
      shift: "Evening",
      experience: "12 years",
      qualification: "MD Pulmonology, MBBS",
      employeeId: "EMP002",
    },
    {
      id: 3,
      name: "Nurse Emily Davis",
      role: "Nurse",
      department: "Emergency",
      specialization: "Emergency Care Nurse",
      phone: "+91-9876543222",
      email: "emily.d@hospital.com",
      address: "789 Nursing Quarters, Mumbai",
      joinDate: "2022-06-10",
      salary: 45000,
      status: "Active",
      shift: "Night",
      experience: "8 years",
      qualification: "BSc Nursing",
      employeeId: "EMP003",
    },
    {
      id: 4,
      name: "Mike Wilson",
      role: "Pharmacist",
      department: "Pharmacy",
      specialization: "Clinical Pharmacist",
      phone: "+91-9876543223",
      email: "mike.w@hospital.com",
      address: "321 Pharmacy Block, Mumbai",
      joinDate: "2021-09-15",
      salary: 55000,
      status: "Active",
      shift: "Morning",
      experience: "10 years",
      qualification: "PharmD",
      employeeId: "EMP004",
    },
    {
      id: 5,
      name: "Lisa Brown",
      role: "Lab Technician",
      department: "Laboratory",
      specialization: "Medical Lab Technologist",
      phone: "+91-9876543224",
      email: "lisa.b@hospital.com",
      address: "654 Lab Complex, Mumbai",
      joinDate: "2022-01-20",
      salary: 35000,
      status: "Active",
      shift: "Morning",
      experience: "6 years",
      qualification: "BSc MLT",
      employeeId: "EMP005",
    },
  ],

  // Sample medicines data
  medicines: [
    {
      id: 1,
      name: "Paracetamol 500mg",
      category: "Analgesic",
      manufacturer: "Sun Pharma",
      batchNumber: "B001234",
      expiryDate: "2025-12-31",
      quantity: 500,
      minStock: 100,
      price: 2.5,
      status: "In Stock",
      supplier: "Medical Distributors Ltd",
      location: "Shelf A-1",
    },
    {
      id: 2,
      name: "Amoxicillin 250mg",
      category: "Antibiotic",
      manufacturer: "Cipla",
      batchNumber: "B002345",
      expiryDate: "2024-08-15",
      quantity: 75,
      minStock: 100,
      price: 8.0,
      status: "Low Stock",
      supplier: "Pharma Supply Co",
      location: "Shelf B-2",
    },
    {
      id: 3,
      name: "Metformin 500mg",
      category: "Antidiabetic",
      manufacturer: "Dr. Reddy's",
      batchNumber: "B003456",
      expiryDate: "2025-06-30",
      quantity: 300,
      minStock: 50,
      price: 3.2,
      status: "In Stock",
      supplier: "Medical Distributors Ltd",
      location: "Shelf C-3",
    },
    {
      id: 4,
      name: "Aspirin 75mg",
      category: "Antiplatelet",
      manufacturer: "Bayer",
      batchNumber: "B004567",
      expiryDate: "2025-03-15",
      quantity: 200,
      minStock: 80,
      price: 1.8,
      status: "In Stock",
      supplier: "Global Pharma",
      location: "Shelf A-4",
    },
    {
      id: 5,
      name: "Omeprazole 20mg",
      category: "Antacid",
      manufacturer: "Lupin",
      batchNumber: "B005678",
      expiryDate: "2024-11-20",
      quantity: 25,
      minStock: 50,
      price: 4.5,
      status: "Low Stock",
      supplier: "Pharma Supply Co",
      location: "Shelf D-1",
    },
  ],

  // Sample lab tests data
  labTests: [
    {
      id: 1,
      testId: "T0001",
      patientName: "John Doe",
      patientId: "P0001",
      testName: "Complete Blood Count",
      category: "Hematology",
      doctorName: "Dr. John Smith",
      date: "2024-01-20",
      status: "Completed",
      results: {
        hemoglobin: "14.5 g/dL",
        wbc: "7500 /μL",
        platelets: "250000 /μL",
        rbc: "4.8 million/μL",
      },
      normalRanges: {
        hemoglobin: "12-16 g/dL",
        wbc: "4000-11000 /μL",
        platelets: "150000-450000 /μL",
        rbc: "4.2-5.4 million/μL",
      },
      cost: 800,
      technician: "Lisa Brown",
    },
    {
      id: 2,
      testId: "T0002",
      patientName: "Jane Smith",
      patientId: "P0002",
      testName: "Lipid Profile",
      category: "Biochemistry",
      doctorName: "Dr. Sarah Johnson",
      date: "2024-01-19",
      status: "Completed",
      results: {
        totalCholesterol: "180 mg/dL",
        hdl: "45 mg/dL",
        ldl: "110 mg/dL",
        triglycerides: "125 mg/dL",
      },
      normalRanges: {
        totalCholesterol: "<200 mg/dL",
        hdl: ">40 mg/dL",
        ldl: "<100 mg/dL",
        triglycerides: "<150 mg/dL",
      },
      cost: 1200,
      technician: "Lisa Brown",
    },
    {
      id: 3,
      testId: "T0003",
      patientName: "Rajesh Kumar",
      patientId: "P0003",
      testName: "ECG",
      category: "Cardiology",
      doctorName: "Dr. John Smith",
      date: "2024-01-21",
      status: "Pending",
      results: {},
      normalRanges: {},
      cost: 500,
      technician: "Mike Wilson",
    },
    {
      id: 4,
      testId: "T0004",
      patientName: "Priya Sharma",
      patientId: "P0004",
      testName: "Thyroid Function Test",
      category: "Endocrinology",
      doctorName: "Dr. Emily Brown",
      date: "2024-01-22",
      status: "In Progress",
      results: {},
      normalRanges: {},
      cost: 1500,
      technician: "Lisa Brown",
    },
  ],

  // Sample inventory data
  inventory: [
    {
      id: 1,
      name: "Surgical Gloves (Latex)",
      category: "Medical Supplies",
      supplier: "MedSupply India",
      quantity: 2000,
      minStock: 500,
      maxStock: 5000,
      unitPrice: 2.5,
      totalValue: 5000,
      lastRestocked: "2024-01-15",
      status: "In Stock",
      location: "Store Room A",
      expiryDate: "2025-01-15",
    },
    {
      id: 2,
      name: "Syringes (10ml)",
      category: "Medical Equipment",
      supplier: "HealthTech Solutions",
      quantity: 150,
      minStock: 300,
      maxStock: 1000,
      unitPrice: 3.2,
      totalValue: 480,
      lastRestocked: "2024-01-10",
      status: "Low Stock",
      location: "Store Room B",
      expiryDate: "2026-01-10",
    },
    {
      id: 3,
      name: "Bandages (Elastic)",
      category: "Medical Supplies",
      supplier: "Care Products Ltd",
      quantity: 0,
      minStock: 100,
      maxStock: 500,
      unitPrice: 15.0,
      totalValue: 0,
      lastRestocked: "2023-12-20",
      status: "Out of Stock",
      location: "Store Room A",
      expiryDate: "2025-12-20",
    },
    {
      id: 4,
      name: "Blood Pressure Monitor",
      category: "Medical Equipment",
      supplier: "MedTech Instruments",
      quantity: 25,
      minStock: 10,
      maxStock: 50,
      unitPrice: 2500.0,
      totalValue: 62500,
      lastRestocked: "2024-01-05",
      status: "In Stock",
      location: "Equipment Room",
      expiryDate: null,
    },
    {
      id: 5,
      name: "Thermometer (Digital)",
      category: "Medical Equipment",
      supplier: "Digital Health Co",
      quantity: 45,
      minStock: 20,
      maxStock: 100,
      unitPrice: 450.0,
      totalValue: 20250,
      lastRestocked: "2024-01-12",
      status: "In Stock",
      location: "Equipment Room",
      expiryDate: null,
    },
  ],

  // Sample bills data
  bills: [
    {
      id: 1,
      billNumber: "B0001",
      patientName: "John Doe",
      patientId: "P0001",
      date: "2024-01-20",
      services: [
        { name: "Consultation - Cardiology", amount: 1000 },
        { name: "Complete Blood Count", amount: 800 },
        { name: "ECG", amount: 500 },
        { name: "Medicines", amount: 450 },
      ],
      totalAmount: 2750,
      paidAmount: 2750,
      status: "Paid",
      paymentMethod: "UPI",
      discount: 0,
      tax: 0,
      insuranceClaim: false,
    },
    {
      id: 2,
      billNumber: "B0002",
      patientName: "Jane Smith",
      patientId: "P0002",
      date: "2024-01-19",
      services: [
        { name: "Consultation - Pulmonology", amount: 1200 },
        { name: "Lipid Profile", amount: 1200 },
        { name: "Chest X-Ray", amount: 800 },
      ],
      totalAmount: 3200,
      paidAmount: 1600,
      status: "Partial",
      paymentMethod: "Cash",
      discount: 0,
      tax: 0,
      insuranceClaim: true,
    },
    {
      id: 3,
      billNumber: "B0003",
      patientName: "Rajesh Kumar",
      patientId: "P0003",
      date: "2024-01-21",
      services: [
        { name: "Consultation - Cardiology", amount: 1000 },
        { name: "ECG", amount: 500 },
      ],
      totalAmount: 1500,
      paidAmount: 0,
      status: "Pending",
      paymentMethod: "",
      discount: 0,
      tax: 0,
      insuranceClaim: false,
    },
    {
      id: 4,
      billNumber: "B0004",
      patientName: "Priya Sharma",
      patientId: "P0004",
      date: "2024-01-22",
      services: [
        { name: "Consultation - Endocrinology", amount: 1200 },
        { name: "Thyroid Function Test", amount: 1500 },
        { name: "Ultrasound", amount: 1000 },
      ],
      totalAmount: 3700,
      paidAmount: 3700,
      status: "Paid",
      paymentMethod: "Card",
      discount: 200,
      tax: 0,
      insuranceClaim: false,
    },
  ],
}
